import { useNavigate } from "react-router-dom";
import { getImageUrl } from "../../../lib/get-image";
import { Image } from "../../shared/index";
import { FaChevronRight } from "react-icons/fa";
import styles from "./collection-item.module.css";

const CollectionItem = ({ category }) => {
  const navigate = useNavigate();

  const { name, slug, cat_image } = category;

  const handleSubCategory = (type) => {
    const catSlug = type?.replace(/\s+/g, "_");
    navigate(`/shop/${catSlug}`);
  };

  return (
    <div 
      className={styles.collection__card}
      onClick={() => handleSubCategory(slug)}
    > 
  
      <div className={styles.left}>
        <Image
          src={getImageUrl(cat_image)}
          alt={name}
          className={styles.image}
        />

     <h3>
  {name?.charAt(0).toUpperCase() + name?.slice(1)}
</h3>
      </div>

      <div className={styles.arrow}>
        <FaChevronRight />
      </div>
    </div>
  );
};

export default CollectionItem;